
import { EMAIL_SIGNATURE } from './EmailSignature';

const EMAIL_HTML_TEMPLATE = `<div dir="ltr">
  <p class="MsoNormal" style="margin:0cm;font-family:Calibri,sans-serif;color:rgb(0,0,0)"><span style="font-family:Arial,sans-serif">Hi [naam],</span></p>
  <p class="MsoNormal" style="margin:0cm;font-family:Calibri,sans-serif;color:rgb(0,0,0)"><span style="font-family:Arial,sans-serif">&nbsp;</span></p>
  <p class="MsoNormal" style="margin:0cm;font-family:Calibri,sans-serif;color:rgb(0,0,0)"><span style="font-family:Arial,sans-serif">Wat leuk dat je interesse hebt in een huisbezoek!&nbsp;</span></p>
  <p class="MsoNormal" style="margin:0cm;font-family:Calibri,sans-serif;color:rgb(0,0,0)"><span style="font-family:Arial,sans-serif">&nbsp;</span></p>
  <p class="MsoNormal" style="margin:0cm;font-family:Calibri,sans-serif;color:rgb(0,0,0)"><span style="font-family:Arial,sans-serif">Wij werken met aankomsttijdsblokken. Dat houdt in dat we nu een tijdsblok van een uur afspreken waarin we aan kunnen komen. Een week voor ons bezoek geven we de exacte aankomsttijd door.&nbsp;</span></p>
  <p class="MsoNormal" style="margin:0cm;font-family:Calibri,sans-serif;color:rgb(0,0,0)"><span style="font-family:Arial,sans-serif">&nbsp;</span></p>
  <p class="MsoNormal" style="margin:0cm;font-family:Calibri,sans-serif;color:rgb(0,0,0)"><span style="font-family:Arial,sans-serif">Op [datum] heb ik voor [type bezoek] in [plaats] nog een aankomsttijdsblok beschikbaar van [tijdsblok start] tot [tijdsblok eind]. Zou dat voor jullie een optie zijn?</span></p>
</div>
${EMAIL_SIGNATURE}`;


/**
 * Generate email content for a visit time slot request
 * @param {Object} data - The data to populate the template
 * @param {string} data.naam - Recipient's name
 * @param {string} data.datum - Visit date
 * @param {string} data.typeBezoek - Type of visit
 * @param {string} data.plaats - Location/city
 * @param {string} data.tijdsblokStart - Time slot start time
 * @param {string} data.tijdsblokEind - Time slot end time
 * @returns {Object} Object containing both HTML and plain text versions
 */
export function generateVisitTimeEmailContent(data: {
    naam: string,
    datum: string,
    typeBezoek: string,
    plaats: string,
    tijdsblokStart: string,
    tijdsblokEind: string
}) {
    const { naam, datum, typeBezoek, plaats, tijdsblokStart, tijdsblokEind } = data;

    // Replace placeholders in HTML template
    const htmlBody = EMAIL_HTML_TEMPLATE
        .replace('[naam]', naam)
        .replace('[datum]', datum)
        .replace('[type bezoek]', typeBezoek)
        .replace('[plaats]', plaats)
        .replace('[tijdsblok start]', tijdsblokStart)
        .replace('[tijdsblok eind]', tijdsblokEind);

    return {
        html: htmlBody,
    };
}

